export default "__VITE_ASSET__C8SNj17m__"